// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  valueIsRequired,
  valueMustBeWithinMaxLength,
} from 'validators/common/simple'

const requiredValueMustBeWithinMaxLength = (v, maxLength) => (
  valueIsRequired(v) ||
  valueMustBeWithinMaxLength(v, maxLength)
)

export default requiredValueMustBeWithinMaxLength
